var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 596 596",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 382 393 C 380 402 377 410 373 417 358 447 330 463 296 459 255 460 193 461 144 443 116 433 89 420 66 400 27 364 22 296 53 253 74 225 102 204 133 187 177 161 228 137 274 135 285 134 295 133 306 133 327 134 342 148 354 164 374 193 384 224 388 258 390 275 391 293 392 310 391 338 390 366 382 393 Z M 349 381 C 358 341 357 299 352 258 349 232 340 207 325 185 323 183 321 181 318 178 317 180 317 182 317 183 315 205 312 228 311 250 308 296 310 341 321 385 324 395 328 404 331 415 341 404 346 393 349 381 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 568 202 C 569 208 565 214 557 215 541 219 524 222 507 224 476 229 444 235 412 240 404 241 398 238 397 231 395 224 400 218 408 217 445 210 483 204 520 197 532 195 544 193 554 192 563 192 568 195 568 202 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 466 351 C 495 355 523 361 552 366 554 366 556 367 558 367 566 369 569 374 568 381 567 387 562 391 554 390 543 388 532 387 522 385 485 379 448 373 411 366 407 366 402 364 400 360 398 357 397 351 398 348 400 345 405 343 408 341 429 345 448 348 466 351 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 416 302 C 407 302 401 296 403 289 403 285 407 281 410 279 412 277 415 278 418 278 466 278 513 278 559 279 569 279 574 283 574 291 574 298 568 303 559 303 L 488 303 488 302 C 465 302 440 302 416 302 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlight);
export default __webpack_public_path__ + "static/media/headlight.004cfec585477bcab1598d20b32c3cd8.svg";
export { ForwardRef as ReactComponent };